import classes from './modal.module.css'

const Modal = {
  classNames: {
    content: classes.content,
    header: classes.header,
    overlay: classes.overlay,
    title: classes.title,
  },
}

export default Modal
